module.exports = __webpack_public_path__ + "static/media/production-control.d81a2f61.png";